import { GitCommitVertical, GitFork, type LucideIcon } from 'lucide-react';

/** Canonical icon mapping for process step action types, used across tables, cards, and selectors. */
export const STEP_ACTION_ICONS = {
  task: GitCommitVertical,
  decision: GitFork
} as const satisfies Record<'task' | 'decision', LucideIcon>;

/** Canonical icon-color mapping matching {@link STEP_ACTION_ICONS}. */
export const STEP_ACTION_ICON_COLORS = {
  task: 'text-info',
  decision: 'text-highlight'
} as const satisfies Record<'task' | 'decision', string>;
